import IconButton from "./IconButton"

export default function DeleteIconButton({ onClick, ...rest }) {
  return (
    <IconButton size="small" name="trash" outline onClick={onClick} {...rest} />
  )
}
